module.exports = __webpack_public_path__ + "img/Icon3.08dd0780.svg";